import { render, staticRenderFns } from "./EventTrends.vue?vue&type=template&id=2dc06db6&scoped=true&"
import script from "./EventTrends.vue?vue&type=script&lang=js&"
export * from "./EventTrends.vue?vue&type=script&lang=js&"
import style0 from "./EventTrends.vue?vue&type=style&index=0&id=2dc06db6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc06db6",
  null
  
)

export default component.exports